import React, {useState, useEffect,  useRef} from "react";
import { api } from "../../services/api";
import styles from "./styles.module.scss";
import Container from "../common/container/Container";
import ResultPanel from "../result/ResultPanel";
import CountryCard from "../countryCard/CountryCard";
import { emptyDeep } from "../../utilities/utils";
import { createPassportsList, createRcbiList } from "../../utilities/option-create";
import { calculatePortfolioOverview, calculateSingleFreeVisaCountries } from "../../utilities/utils";
import LoadingSpinner from "../common/loading/LoadingSpinner";

const Portfolio = () => {

  const [portfolioData, setPortfolioData] = useState(null);
  const [passportData, setPassportData] = useState(null);
  const [passportOpts, setPassportOpts] = useState(null);
  const [rcbiOpts, setRcbiOpts] = useState(null);

  const [selectedPassport, setSelectedPassport]= useState({
    passport1: '',
    passport2: '',
  });
  const [selectedRCBI, setSelectedRCBI] = useState({
    tile1: '',
    tile2: '',
    tile3: '',
    tile4: ''
  });
  const [passportCountries, setPassportCountries] = useState([]);
  const [RCBICountries, setRCBICountries] = useState([]);
  const resultRef = useRef(null);

  const ADDPASSPORT_BUTTONS_TOTAL = 2;
  const ADDRCBI_BUTTONS_TOTAL = 4;

  useEffect(() => {
    async function fetchData() {
      const responsePortfolio = await api.get("/portfolio");
      const resonpsePassport = await api.get("/passport");

      // const responses = await Promise.all([api.get("/portfolio"), api.get("/passport")]);
      setPortfolioData(responsePortfolio.data);
      setPassportData(resonpsePassport.data)
      setPassportOpts(createPassportsList(responsePortfolio.data));
      setRcbiOpts(createRcbiList(responsePortfolio.data));
    }
    fetchData();
  }, []);


  useEffect(() => {
 
    // console.log('Passport: ' + emptyDeep(selectedPassport));
    // console.log('RCBI: ' + emptyDeep(selectedRCBI));

    const passportArr = [];
    const RCBIArr = [];

    for(let x = 1; x <= ADDPASSPORT_BUTTONS_TOTAL; x++){
      if(selectedPassport[`passport${x}`]){
        let passportObj = {};
        passportObj['iso_code'] = selectedPassport[`passport${x}`].iso_code;
        passportObj['type'] = false;
        passportArr.push(passportObj);
      }
    }

    for(let y = 1; y <= ADDRCBI_BUTTONS_TOTAL; y++){
      if(selectedRCBI[`tile${y}`]){
        let RCBIObj = {};
        RCBIObj['iso_code'] = selectedRCBI[`tile${y}`].iso_code;
        RCBIObj['type'] = selectedRCBI[`tile${y}`].type
        RCBIArr.push(RCBIObj);
      }
    }

    setPassportCountries(passportArr);
    setRCBICountries(RCBIArr);
    // console.log(passportArr);
    // console.log(RCBIArr);

  }, [selectedPassport, selectedRCBI]);

  
    useEffect(() => {
 
    if(emptyDeep(selectedPassport)){
        setSelectedRCBI({
            tile1:'',
            tile2:'',
            tile3:'',
            tile4:''
        });
    }

    }, [selectedPassport]);

  const handleSelect = (option, index, cardType) =>{
    const countryData = calculatePortfolioOverview(portfolioData, {iso_code:option.iso_code, type:option.type});
    const freeVisaCountries = calculateSingleFreeVisaCountries(passportData, {iso_code: option.iso_code, type: option.type});
    const obj = {
      value:option.value, 
      label:option.label, 
      iso_code: option.iso_code, 
      type: option.type,
      countryData: countryData,
      freeVisaCountries: freeVisaCountries
    }
    if(cardType === 'Passport'){
      setSelectedPassport({
        ...selectedPassport,
        [index]: obj
      });
      // console.log(option.iso_code.toUpperCase());
    }else if(cardType === 'RCBI'){
      setSelectedRCBI({
        ...selectedRCBI,
        [index]: obj
      })
    }
  }

  const handleClear = (index, cardType) =>{
    if(cardType === 'Passport'){
      setSelectedPassport({
        ...selectedPassport,
        [index]: ''
      });
    }else if(cardType === 'RCBI'){
      setSelectedRCBI({
        ...selectedRCBI,
        [index]: ''
      });
    }
  }

  const onClickToPosition = () =>{
    resultRef.current.scrollIntoView({ behavior: "smooth" });
  }


  const renderPassportCardTile = (options, selected) => {
    const length = Array.from(Array(ADDPASSPORT_BUTTONS_TOTAL).keys());
    return length.map((i) => {
      const key = i + 1;
      return <div className="col-12 col-md-6 mb20" key={`passport-${key}`}>
      <CountryCard
        cardType="Passport"
        emptyText={`My Passport ${i + 1}`}
        minHeight="400px"
        optionList={options}
        onSelectChange={(option) => handleSelect(option, `passport${key}`, 'Passport')}
        selectedValue={selected[`passport${key}`]}
        onClickToPosition={onClickToPosition}
        onClearClick={() => handleClear(`passport${key}`, 'Passport')}
      />
    </div>
    });
  }

  const renderRCBICardTile = (options, selected) => {
    const length = Array.from(Array(ADDRCBI_BUTTONS_TOTAL).keys());
    return length.map((i) => {
      const key = i + 1;
      return <div className="col-12 col-md-6 col-lg-3 mb20" key={`tile-${key}`}>
      <CountryCard
        emptyText={
          <span>
            Add Investment
            <br /> Migration Program
          </span>
        }
        minHeight="240px"
        optionList={options}
        onSelectChange={(option) => handleSelect(option, `tile${key}`, 'RCBI') }
        selectedValue={selected[`tile${key}`]}
        cardType={selected[`tile${key}`].type}
        onClickToPosition={onClickToPosition}
        onClearClick={() => handleClear(`tile${key}`, 'RCBI')}
      />
    </div>
    });
  }

  if (!portfolioData) return <LoadingSpinner />;

  return (
    <Container>

      <div className="row flex-md-row-reverse">
        <div ref={resultRef} className="col-12 col-md-4 mb50">
          <div className={styles.resultWrapper}>
            <div className={styles.resultTextContent}>
              <h3>My Ultimate Portfolio</h3>
              <p className="text-hblue">Creating a portfolio of residence and citizenship options is the best possible investment you can make to guarantee your personal access rights to the world and future-proof your wealth and safeguard your legacy for future generations.</p>
              <div className="mt10">Select GLOBAL ACCESS to see a list of all the countries you can access visa-free with your Ultimate Portfolio.</div>
            </div>
            {!emptyDeep(selectedPassport) && !emptyDeep(selectedRCBI) &&
            <ResultPanel passports={passportCountries} RCBIs={RCBICountries} />
            }
          </div>
          
        </div>
        <div className="col-12 col-md-8">
          <div className={styles.firstStep}>
            <div className={styles.step}>
              <strong>Step 1</strong> - Add up to two passport/s you currently hold to see the number of destinations you can access visa-free and the scores out of 100 for seven key country strengths and benefits:
            </div>
            <div className="row">
              {passportOpts && renderPassportCardTile(passportOpts, selectedPassport)}
            </div>
          </div>
          
          {!emptyDeep(selectedPassport) &&
          <div className="mt10">
            <div className={styles.step}>
              <strong>Step 2</strong> - To create your Ultimate Portfolio, add up to four investment migration program options that will provide you with additional citizenships or residence rights, greater global mobility, and greater country benefits. Change program options to discover the best combination for you and your family:
            </div>

            <div className="row">
              {renderRCBICardTile(rcbiOpts, selectedRCBI)}
            </div>

            <div className="mt10">Note: Find out the list of visa-free destinations for each passport and residence permit <a href="https://www.henleyglobal.com/passport-index/improve" className="text-underline" target="_blank" rel="noreferrer">here</a>.</div>
          </div>
          }

          
        </div>
        
      </div>
    </Container>
  );
};

export default Portfolio;
